class ReviewsSection extends HTMLElement {
    constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);
      this.pageOverlayElement = document.querySelector('.site-overlay');
      this.bindEvents();
      this.initialConfig = JSON.parse(
        this.element.getAttribute("data-section-config")
      );
  
      new AddToCart(this.element);
    }
    bindEvents(){
      this.delegateElement.on('click','[data-action="open-wrapper"]', this.openModal.bind(this));
      this.delegateElement.on('click','[data-action="close-wrapper"]', this.closeModal.bind(this));
      this._closeListener = this.closeModal.bind(this);
    }
  
    openModal(event) {
      event.preventDefault();
      event.stopPropagation();
  
      this.pageOverlayElement.classList.add('active');
      this.video = event.target;
  
      // Dohvati podatke o proizvodu
      const productHandle = this.video.getAttribute('data-product-handle');
      const productId = this.video.getAttribute('data-product-id');
      const productTitle = this.video.getAttribute('data-product-title');
      const productSubtitle = this.video.getAttribute('data-product-subtitle');
      const productImage = this.video.getAttribute('data-product-image');
      const productPrice = this.video.getAttribute('data-product-price');
      const compareAtPrice = this.video.getAttribute('data-product-compare-at-price');
      const discount = this.video.getAttribute('data-product-discount');
      const productVariantId = this.video.getAttribute('data-product-variant-id');
      const langAtc = this.video.getAttribute('lang-atc');
    
      // Kreiraj HTML strukturu sa video i informacijama o proizvodu
      const modalContainer = document.createElement('div');
      modalContainer.classList.add('modal-product-container');
  
      modalContainer.innerHTML = `
          <div class="videoModal">
              <div class="video-container">
                  ${this.video.outerHTML}
              </div>
              <div class="product-info-container">
                  <div class="FloatingProduct">
                      <div class="FloatingLeft">
                          <div class="FloatingImage">
                              <img src="${productImage}" alt="${productTitle}" />
                          </div>
                          <div class="FloatingInfo">
                              <div class="Title">${productTitle}</div>
                              <div class="Subtitle">${productSubtitle}</div>
                              <div class="FP__Price__Wrapper">
                                  ${productPrice ? `<span class="product-price">${productPrice}</span>` : ''}
                                  ${compareAtPrice && compareAtPrice > productPrice ? `<span class="info compare-price">${compareAtPrice}</span>` : ''}
                                  
                              </div>
                          </div>
                      </div>
                      <div class="FloatingActions">
                      ${discount ? `<div class="Discount__Regular--noremove"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.48202 13.0409L1.55745 12.4917C1.14802 12.2485 0.894693 11.8097 0.888795 11.3336L0.875477 10.2583C0.872647 10.0298 0.812608 9.80578 0.700848 9.60654L0.174734 8.66865C-0.0582446 8.25332 -0.0582446 7.74668 0.174734 7.33135L0.700848 6.39346C0.812608 6.19422 0.872647 5.97015 0.875477 5.74173L0.888795 4.66644C0.894693 4.19026 1.14802 3.75149 1.55745 3.5083L2.48202 2.95912C2.67842 2.84245 2.84245 2.67842 2.95912 2.48202L3.5083 1.55745C3.75149 1.14802 4.19026 0.894693 4.66644 0.888795L5.74173 0.875477C5.97015 0.872647 6.19422 0.812608 6.39346 0.700848L7.33135 0.174734C7.74668 -0.0582446 8.25332 -0.0582446 8.66865 0.174734L9.60654 0.700848C9.80578 0.812608 10.0298 0.872647 10.2583 0.875477L11.3336 0.888795C11.8097 0.894693 12.2485 1.14802 12.4917 1.55745L13.0409 2.48202C13.1575 2.67842 13.3216 2.84245 13.518 2.95912L14.4426 3.5083C14.852 3.75149 15.1053 4.19026 15.1112 4.66644L15.1245 5.74173C15.1274 5.97015 15.1874 6.19422 15.2992 6.39346L15.8253 7.33135C16.0582 7.74668 16.0582 8.25332 15.8253 8.66865L15.2992 9.60654C15.1874 9.80578 15.1274 10.0298 15.1245 10.2583L15.1112 11.3336C15.1053 11.8097 14.852 12.2485 14.4426 12.4917L13.518 13.0409C13.3216 13.1575 13.1575 13.3216 13.0409 13.518L12.4917 14.4426C12.2485 14.852 11.8097 15.1053 11.3336 15.1112L10.2583 15.1245C10.0298 15.1274 9.80578 15.1874 9.60654 15.2992L8.66865 15.8253C8.25332 16.0582 7.74668 16.0582 7.33135 15.8253L6.39346 15.2992C6.19422 15.1874 5.97015 15.1274 5.74173 15.1245L4.66644 15.1112C4.19026 15.1053 3.75149 14.852 3.5083 14.4426L2.95912 13.518C2.84245 13.3216 2.67842 13.1575 2.48202 13.0409ZM5.27988 10.1782C5.03729 10.4673 5.075 10.8983 5.36411 11.1409C5.65323 11.3835 6.08426 11.3458 6.32686 11.0567L10.7194 5.82183C10.962 5.53271 10.9243 5.10168 10.6352 4.85908C10.3461 4.61649 9.91505 4.6542 9.67245 4.94331L5.27988 10.1782ZM6.55002 6.55037C7.08376 6.01663 7.08376 5.15127 6.55002 4.61753C6.01629 4.08379 5.15092 4.08379 4.61718 4.61753C4.08344 5.15127 4.08344 6.01663 4.61718 6.55037C5.15092 7.08411 6.01629 7.08411 6.55002 6.55037ZM11.3821 11.3825C11.9159 10.8487 11.9159 9.98337 11.3821 9.44963C10.8484 8.91589 9.98302 8.91589 9.44929 9.44963C8.91555 9.98337 8.91555 10.8487 9.44929 11.3825C9.98302 11.9162 10.8484 11.9162 11.3821 11.3825Z" fill="#F80B00"/>
</svg>${discount}% OFF</div>` : ''}
                          <form id="add-to-cart-form">
                              <input type="hidden" name="id" value="${productVariantId}">
                              <button type="submit" class="button_alt color">
                                  <span class="add-to-cart-text">${langAtc}</span>
                              </button>
                          </form>
                      </div>
                  </div>
              </div>
          </div>
      `;
  
      document.body.appendChild(modalContainer);
  
      // Event listener za dodavanje u korpu
      const addToCartForm = modalContainer.querySelector('#add-to-cart-form');
      addToCartForm.addEventListener('submit', (e) => {
          e.preventDefault();
          const variantId = addToCartForm.querySelector('input[name="id"]').value;
  
          fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify({ id: variantId, quantity: 1 })
          })
          .then(response => response.json())
          .then(data => {
              
          })
          .catch(error => {
              console.error('Error adding product to cart:', error);
          });
          this.closeModal();
      });
  
      this.pageOverlayElement.addEventListener("click", this._closeListener);
  
      if (document.body.querySelector('.pp-overflow')) {
          document.body.querySelector('.pp-overflow').style.position = "relative";
      }
  
      const closeIcon = '<svg class="closeModal" data-action="close-wrapper" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M24.9426 7.05721C25.4633 7.57791 25.4633 8.42213 24.9426 8.94283L8.94265 24.9428C8.42195 25.4635 7.57773 25.4635 7.05703 24.9428C6.53633 24.4221 6.53633 23.5779 7.05703 23.0572L23.057 7.05721C23.5777 6.53651 24.4219 6.53651 24.9426 7.05721Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.05703 7.05721C6.53633 7.57791 6.53633 8.42213 7.05703 8.94283L23.057 24.9428C23.5777 25.4635 24.4219 25.4635 24.9426 24.9428C25.4633 24.4221 25.4633 23.5779 24.9426 23.0572L8.94265 7.05721C8.42195 6.53651 7.57773 6.53651 7.05703 7.05721Z" fill="white"/></svg>';
      this.pageOverlayElement.innerHTML = closeIcon;
    }
  
  
    closeModal(){
      this.pageOverlayElement.classList.remove('active');
      this.videoHolder = this.video = document.body.querySelector('.videoModal');
          this.video = this.videoHolder.querySelector('.wrapper_click--video');
      if(this.initialConfig['use_plh'] == true){
        this.videoHolder.style.opacity = 0;
        videojs('my-player-'+this.video.getAttribute('data-id')).pause();
      }else{
        this.videoHolder.remove();
      }
        this.videoHolder.classList.remove('videoModal');
        this.pageOverlayElement.querySelector('.closeModal').remove();
        if(document.body.querySelector('.pp-overflow')){
                document.body.querySelector('.pp-overflow').style.position = "sticky";
        }
  
        this.pageOverlayElement.removeEventListener("click", this._closeListener);
    }
  
  
  
  }
  
  customElements.define("reviews-section", ReviewsSection);